import React, { Component } from "react";
import mixpanel from "mixpanel-browser";
import Headshot from "../Assets/headshot-min.jpg";
class Bye extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    let user_id = this.props.match.params.USER_ID;
    mixpanel.track("uninstall", { USER_ID: this.props.match.params.USER_ID });
  }

  render() {
    return (
      <div className="center">
        <h1 className="headline" style={{ margin: "0px" }}>
          🥲 Sorry to see you go
        </h1>
        <h2 className="subheadline" style={{ margin: "30px 0px" }}>
          Would you mind taking a moment to provide feedback? Your responses help our small team immensely with improving Audioread to empower learners everywhere. Thank you in advance :)
        </h2>
        <iframe 
          title="Cancellation feedback form"
          src="https://docs.google.com/forms/d/e/1FAIpQLScUs5lPIz6wGtvV0k1roO6BWZu_zm-ELYCCMsDX4f2FRLySmw/viewform?embedded=true"
          width="100%" 
          height="1600px"
          frameBorder="0" 
          marginHeight="0" 
          marginWidth="0"
        >
          Loading form...
        </iframe>
        {/* <div
          style={{
            display: "flex",
            width: "800px",
            backgroundColor: "rgba(35,22,49,0.85)",
            padding: "25px",
            borderRadius: "25px",
          }}
        >
          <div>
            <img
              src={Headshot}
              style={{
                height: "100px",
                width: "100px",
                borderRadius: "100%",
              }}
            />

            <div>
              <b>Eric Jung, Founder</b>
            </div>
          </div>

          <div
            style={{
              fontSize: "larger",
              textAlign: "left",
              padding: "17px",
            }}
          >
            Hi, founder Eric here. As a solo full-time developer, I miss out on
            lots of opportunities to improve the service, and it's really
            painful to watch people get disappointed & leave! Would you mind
            filling out the survey below and helping us understand what we
            could've done better?
          </div>
        </div> */}

      </div>
    );
  }
}

export default Bye;
